export const environment = {
  production: false,

  clientName: 'biocosta',
  apiGatewayFront: 'https://agp.bgreen.com.co/',
  apiGatewayBackOffice: 'https://agp.bgreen.com.co/',
  apiUrl: 'https://agp.bgreen.com.co/',
  urlPath: 'https://agp.bgreen.com.co/',
  customCss: false,
  // Whether or not to enable debug mode
  // Setting this to false will disable console output
  enableDebug: false,
  // siteKeyCaptcha: '6LdLtBsgAAAAAJksLT4W-TI-oRed7Uk9B8Y-EECB', DEMO
  // siteKeyCaptcha: '6LfL5fkfAAAAALmrMTjEg18wnQm5uR3ZNbBy-pL7' ZX

  siteKeyCaptcha: '6Lf8FtgpAAAAAM0chElolEVPdkdav7Lb3LxAVrFq',

  googleAnalyticsCode: 'UA-140785247-1',
};